import React from "react";
import '../Styles/Disclaimer.scss';
import { useEffect } from "react";
import { useState } from "react";
import { differenceInYears, parseISO } from "date-fns";
import { CombinationPageOptions } from "../Constants/RegistrationPageOptions";

// React component displaying the disclaimer and parent signature information of the registration portal

function Disclaimer({signatureData, setSignatureData, camperType, groupJoined,
   week, promoCode, selectedPage, setSelectedPage, guestId, setGuestId,
   nextPage, previousPage}){

   const [camperAgeInYears, setCamperAgeInYears]      = useState('')
   const [disclaimerError, setDisclaimerError]        = useState(false)
   const [signatureDateError, setSignatureDateError]  = useState(false)
   var currentDate = new Date().toLocaleDateString();

   const isRetreat = week?.camp_type === 'Retreat';

   const resolvedNextPage     = nextPage     ?? CombinationPageOptions.Review;
   const resolvedPreviousPage = previousPage ?? CombinationPageOptions.CamperType;

   function handleNext() {
      setSignatureData({...signatureData, signatureDate: (currentDate)})
      if(signatureData.signature === '' || signatureData.signatureDate === ''){
         setDisclaimerError('true')
      }
      else{
         setSelectedPage(resolvedNextPage)
      }

   }
   return (
   <div>
      {camperAgeInYears >= 18 &&
         <div className="SkippingDisclaimerMessageContainer">
            <div className="SkippingDisclaimerMessageContent">
               <div className="SkippingDisclaimerMessageText">
                  Skipping Parent Signature, over 18 years of age.
               </div>
            </div>
         </div>
      }
      {camperAgeInYears < 18 &&
         <div className="DisclaimerContent">
         <div className="DisclaimerContainer">
            <form>
               <h2>Disclaimer</h2>
               <div className="disclaimerMedicalBody">
                  {isRetreat ?
                     <p className="disclaimerMedicalDisclaimer">
                        I agree to abide by all camp rules and will assume full responsibility for my physical welfare and will not hold the
                        Bill Rice Ranch liable in case of sickness or accident.
                     </p>
                     :
                     <>
                        <p className="disclaimerMedicalDisclaimer">
                           I hereby give permission for my child/dependent to take part in all Ranch activities including sports and horseback riding (unless otherwise indicated) and absolve the Ranch from
                           liability to me or my child because of any injury received while attending camp at the Bill Rice Ranch. In case of any accident or serious illness, I hereby authorize the Ranch to call
                           upon a physician of their choice and to follow his instructions. If emergency treatment or hospitalization is required, I request the Ranch to notify me. I give my consent to the Ranch
                           to include picture, video, or other likenesses of myself or my children in promotional materials.
                        </p>
                        <p className="disclaimerMedicalRelease">
                           Staff is authorized to release my above named child to the individuals listed below or to me ONLY and in accordance with the stated pick-up procedures. I understand that my child
                           will NOT be permitted to leave the camp with anyone not listed below. All authorized individuals will be required to show identification in order to pick up my child each day.
                        </p>
                     </>
                  }
                  <p className="disclaimerMedicalEsignature">
                     By typing your name into this field, you are signing this agreement electronically. You agree your electronic
                     signature is the legal equivalent of your manual/handwritten signature on this agreement. By typing your name
                     using any device, means or action, you consent to the legally binding terms and conditions of this agreement.
                  </p>
                  <div className="disclaimerMedicalSignature">
                     <div className='disclaimerMedicalSignatureInput1'>
                        <label>{isRetreat ? <>Signature:*</> : <>Parent/Guardian <br></br> (signature):*</>}</label>
                        <input
                           type="text"
                           required
                           value={signatureData.signature}
                           onChange={event => setSignatureData({...signatureData, signature: (event.target.value)})}
                        />
                     </div>
                     <div className='disclaimerMedicalSignatureInput2'>
                        <label>Date:<br></br>{currentDate}&nbsp;</label>
                     </div>
                  </div>
                  <div className="disclaimerCampDisclaimer"> * Fields are required</div>

               </div>
            </form>
            {disclaimerError === true &&
               <div className="disclaimerError">
                  Signature must be signed and dated.
               </div>
            }
            {signatureDateError === true &&
               <div>
                  Signature date must be today's date.
               </div>
            }
            <div className="DisclaimerButtons">
            <div className="DisclaimerPreviousButton">
               <button onClick={()=>setSelectedPage(resolvedPreviousPage)}>
                  Previous
               </button>
            </div>
            <div className="DisclaimerNextButton">
               <button onClick={()=>handleNext()}>
                  Next
               </button>
            </div>
      </div>
         </div>
      </div>
      }
      </div>
   )
}

export default Disclaimer;
